<section class="section">
	<div class="container">
		<div class="columns">
			<div class="column is-three-fifths">
				<div class="columns">
					<div class="column has-text-centered">
						<h5 class="title blue is-5 margin-bottom">Estado de México</h5>
						<div class="column-content">
							<p class="has-text-weight-bold">Laboratorio</p>
							<a class="has-text-weight-bold" href="tel:+525553885638">(55) 5388 5638</a>
							<a href="mailto:ventas.calibraciones@ cccisa.com.mx" class="has-text-weight-bold">ventas.calibraciones@cccisa.com.mx</a>
							<a class="address-link" href="https://www.google.com/maps/place/Centro+de+Calibraci%C3%B3n+y+Capacitaci%C3%B3n+Industrial+S.A.+de+C.V.+CCCISA/@19.5526369,-99.2153165,17z/data=!3m1!4b1!4m5!3m4!1s0x85d21d14a38ef1fd:0xc7e78eb0e8c39b2b!8m2!3d19.5526319!4d-99.2131278">
								Calle la paz #233, Fracc. Valle dorado Tlalnepantla de baz, Estado de mex. CP 54020
							</a>
							<iframe width="100%" height="auto" frameborder="0" style="border:0" src="https://www.google.com/maps/embed/v1/place?key=AIzaSyC8mMb1b9CIZl-rsymdPK_ZKy73YBHDJ58&q=place_id:ChIJ_fGOoxQd0oURK5vD6LCO58c" allowfullscreen></iframe>
						</div>
					</div>
				</div>
				<a class="is-size-5 has-text-weight-bold has-text-centered" href="mailto:cccisa@cccisa.com.mx">
					cccisa@cccisa.com.mx
				</a>
				<div class="is-flex social-div">
					<a class="social-bubble" href="https://twitter.com/LABCCCISA">
						<img src="/assets/img/twitter.svg" style="height: 50px"/>
					</a>
					<a class="social-bubble" href="#">
						<img src="/assets/img/linked.svg" style="height: 50px"/>
					</a>
				</div>
			</div>
			<div class="column is-flex" style="align-items: center">
				<app-contact-form style="width: 100%" title="Contáctanos"></app-contact-form>
			</div>
		</div>
	</div>
</section>
